/**
 * @file Low.jsx
 * @exports Low
 */
import React from 'react'

const red = '#D00000'
const defaultColor = red

const Low = function Low ({ style }) {
  return (
    <svg
      id='low-icon'
      preserveAspectRatio='xMidYMid meet'
      style={style}
      viewBox='0 0 18 18'
    >
      <title>low</title>
      <path
        fill={defaultColor}
        d='m 8,1 h 2 l 0,12 H 13 l -4,4 -4,-4 h 3 z'
      />
    </svg>
  )
}

export default Low
